import createBrowserHistory from 'history/lib/createBrowserHistory'
import createHashHistory from 'history/lib/createHashHistory'
import { useRouterHistory } from 'react-router'
import RA from 'ra-config'

export default function getRouterHistory() {
  switch (RA.app.page.routeStrategy) {
    case 'hash':
      return useRouterHistory(createHashHistory)()
    case 'hashbang':
      return useRouterHistory(createHashHistory)({
        hashType: 'hashbang'
      })
    default:
      return useRouterHistory(createBrowserHistory)({
        basename: getBaseRoute()
      })
  }
}

function getBaseRoute() {
  let path = location.pathname

  // If routePageFileName is not set or empty string, assume root (for heroku)
  if (!RA.app.page.routePageFileName) {
    return '/'
  }

  // Base route is the URL path up to and including the actual page
  let base = path.substring(
    0,
    path.indexOf(RA.app.page.routePageFileName) +
      RA.app.page.routePageFileName.length
  )

  // If viewing page in Author environment, rewrite rules
  // may not be in place to remove html extension
  if (path.indexOf('.html') >= 0 && base.indexOf('.html') < 0) {
    base += '.html'
  }

  return base
}



// WEBPACK FOOTER //
// ./src/config/route-strategy.js